// extracted by mini-css-extract-plugin
export default {"-large":"YQQ8X2kWKwrrymQdfciv","infoContainer":"BLvaAh0S4ggq6wmvngFl","teacher":"IiPBVag3alNV_Yhs3xb7","loginBtnContainer":"ekwdVvn5TAumVkNhWRHZ"};